import React, { createContext, useContext, ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface SiteSettingsContextType {
  settings: Record<string, string>;
  isLoading: boolean;
}

const SiteSettingsContext = createContext<SiteSettingsContextType | undefined>(undefined);

export const SiteSettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: settings = {}, isLoading } = useQuery({
    queryKey: ['site-settings'],
    queryFn: async () => {
      const { data } = await supabase.from('site_settings').select('key, value');
      const map: Record<string, string> = {};
      data?.forEach((s) => {
        map[s.key] = s.value;
      });
      return map;
    },
  });

  return (
    <SiteSettingsContext.Provider value={{ settings, isLoading }}>
      {settings.background_image && (
        <style>
          {`
            body {
              background-image: url('${settings.background_image}');
              background-attachment: fixed;
              background-size: cover;
              background-position: center;
            }
          `}
        </style>
      )}
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (context === undefined) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};
